import React from 'react';
import { Modal, Progress } from 'antd';

const DownloadModal = ({
  visible,
  onOk,
  onCancel,
  isGenerating,
  progress
}) => {
  return (
    <Modal
      title="下载面单"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="确认"
      cancelText="取消"
      okButtonProps={{ disabled: isGenerating }}
      cancelButtonProps={{ disabled: isGenerating }}
    >
      {isGenerating ? (
        <div>
          <p>正在生成面单，请稍候...</p>
          <Progress percent={progress} status="active" />
        </div>
      ) : (
        <p>确定下载选中订单的面单PDF文件吗？</p>
      )}
    </Modal>
  );
};

export default React.memo(DownloadModal);
